import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import vuetify from './plugins/vuetify';
import apiClient from './plugins/api-client';
import './plugins/vue-resource';

import router from './router'
import './assets/css/main.css';

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.prototype.$apiClient= apiClient();

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')

